<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-business-center`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.432 1.914l.103.056 21 13.281a1 1 0 01.457.718l.008.127V46a1 1 0 01-.883.993L43 47H5a1 1 0 01-.993-.883L4 46V25.118a1 1 0 01.445-.832l.108-.062L21 15.999V2.816a1 1 0 01.1-.436l.055-.099a1 1 0 011.277-.367zM25 8.262V43h6v-6.281a1 1 0 011-1h3a1 1 0 011 1v6.28L40 43V17.749L25 8.262zM8 26.972l13-6.5V43H8V26.972z"/></svg>
</template>
<script>

export default {
  name: 'IconBusinessCenter',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
